import { Monitor } from '~types/index'

const GQLmonitor: Monitor = (type, observer) => {
  let mapped = ''
  if (type === 'deadpool-request') {
    mapped = JSON.stringify(observer)
    console.log('Monitor - request', mapped)
  }
  if (type === 'deadpool-response') {
    const { time, end } = observer
    const fromCache = time < 5
    mapped = JSON.stringify({ time, end, fromCache })
    console.log(`Monitor - response ${observer?.operationName || ''}`, mapped)
  }
  return mapped
}

export default GQLmonitor
